import classNames from 'classnames';

import styles from './CircularBadge.module.css';

interface CircularBadgeProps {
  value: number | string;
  size?: 'sm' | 'md' | 'lg';
  colorScheme?: string;
}

/**
 * Count pill used by the tree pickers. Plain spans: the module owns every
 * visual, so a Tag/Text primitive would only contribute styles this immediately
 * overrides.
 */
export const CircularBadge = ({ value, size = 'sm' }: CircularBadgeProps) => {
  const badgeSizeClass = {
    sm: styles.badgeSmall,
    md: styles.badgeMedium,
    lg: styles.badgeLarge,
  };

  const textSizeClass = {
    sm: styles.textSmall,
    md: styles.textMedium,
    lg: styles.textLarge,
  };

  return (
    <span className={classNames(styles.badge, badgeSizeClass[size])}>
      <span className={textSizeClass[size]}>{value}</span>
    </span>
  );
};
